import styled from 'styled-components';
import { black, white } from '@avangard/ui/colors';

import { useCurrentUser } from '@modules/auth/hooks';

import type { ChatEntity } from '@modules/chat/entities';

type ChatsListItemProps = {
    chat: ChatEntity;
    onClick: () => void;
};

const ChatsListItem = (props: ChatsListItemProps) => {
    const { chat, onClick } = props;

    const { currentUser } = useCurrentUser();

    const lastMessage = chat.getLastMessage();

    return (
        <Root onClick={onClick}>
            {lastMessage ? (
                <>
                    <Header>
                        <p>{lastMessage.getSenderTitle()}</p>

                        <p>
                            <span>{lastMessage.getCreatedAtTime()}</span>
                        </p>
                    </Header>

                    <Content>{lastMessage.message}</Content>
                </>
            ) : (
                <>
                    <Header>
                        <p>{chat.getChatTitle(currentUser)}</p>
                    </Header>

                    <Content>
                        <br />
                    </Content>
                </>
            )}
        </Root>
    );
};

const Root = styled.div`
    width: 100%;
    padding: 16px;
    transition: background-color 0.2s;

    cursor: pointer;

    &:hover {
        background-color: ${white[80]};
    }
`;

const Header = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    color: ${black[54]};
    font-size: 1.2rem;
`;

const Content = styled.div`
    max-width: 85%;
    margin-top: 8px;

    font-size: 1.4rem;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;

export { ChatsListItem };
